export default __webpack_public_path__ + "static/media/upgrade-report3.96478009.png";